<template>
  <div :class="{ sp: $device.isMobile }" class="fac-header">
    <kcs-area-label
      :prefecture="labels.prefecture"
      :city="labels.city"
      :enable-link="true"
      :facility-type="labels.facilityType"
    />
    <kcs-social-button :urls="shareUrls" v-if="!$device.isMobile" />
    <h1 class="fac-name">{{ detail.name }}</h1>
    <p class="fac-lead hide-sp">{{ detail.introduction }}</p>
    <p class="fac-point">
      <kcs-rating
        :rating="detail.rating || 0"
        :enable-score="true"
        anchor-link="#review"
      />
    </p>
    <kcs-tag
      :tags="detail.tags"
      :prefecture="labels.prefecture"
      v-if="!$device.isMobile"
    />
    <template v-if="$device.isMobile">
      <kcs-ads-sp-top v-if="$device.isMobile" />
      <kcs-facility-image-slide
        :detail="detail"
        :detail-images="detailImages"
      />
      <p class="fac-lead">{{ detail.introduction }}</p>
      <kcs-tag :tags="detail.tags" :prefecture="labels.prefecture" />
    </template>
    <kcs-facility-infection-info-list :detail="detail" />
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsAreaLabel from '@/components/atoms/kcs-area-label.vue'
import KcsRating from '@/components/atoms/kcs-rating.vue'
import KcsSocialButton from '@/components/molecules/kcs-social-button.vue'
import KcsTag from '@/components/atoms/kcs-tag.vue'
import KcsFacilityImageSlide from '@/components/molecules/kcs-facility-image-slide.vue'
import KcsFacilityInfectionInfoList from '@/components/molecules/kcs-facility-infection-info-list.vue'
import KcsAdsSpTop from '@/components/molecules/kcs-ads-sp-top.vue'
export default {
  components: {
    KcsAreaLabel,
    KcsRating,
    KcsSocialButton,
    KcsTag,
    KcsFacilityImageSlide,
    KcsFacilityInfectionInfoList,
    KcsAdsSpTop
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    detailImages: {
      type: Array,
      required: true
    },
    shareUrls: {
      type: Object,
      required: true
    }
  },
  computed: {
    labels() {
      // エリア、都道府県、市区町村を取得
      return methods.getAreaLabel(this.detail)
    }
  }
}
</script>
